function AboutSection() {
  return (
    <section className="relative bg-accent-50/50 py-20 md:py-28">
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">

        {/* Top Area — Label + Paragraph */}
        <div className="mb-0">
          <p className="text-xs md:text-sm font-medium uppercase tracking-[0.2em] text-foreground-500 mb-8">
            Engineering Philosophy
          </p>
          <div className="max-w-3xl">
            <p className="text-lg md:text-xl lg:text-2xl text-foreground-700 leading-relaxed font-light">
              The team builds scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality. Following modern software engineering practices including clean architecture, performance optimization, and user-centered design, every solution is crafted with precision and purpose. The company emphasizes continuous innovation, improvement of development workflows, and adoption of up-to-date engineering standards to deliver reliable and future-ready IT solutions. By actively exploring new technologies and evolving internal processes, the team maintains high technical excellence across all engineering efforts.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default AboutSection;